import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { IForum } from '@fi-shared/fi-forum/fi-forum';
import { FiForumSharedService } from '@fi-shared/fi-forum/fi-forum-shared.service';
import { Subject } from 'rxjs';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiItemsDeleteHelperService } from '@fi-shared/fi-shared-services/fi-items-delete-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-forum-view-container',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <!--<div class="fi-header-actions">
                    <fi-button-back-new></fi-button-back-new>
                </div>-->
                <div class="fi-header-text">{{ forum.Name }}</div>
                <div class="fi-header-actions right-aligned">
                    <fi-page-header-button-group
                        [isDeleteButtonShown]="forum.HasEditAccess"
                        [isEditButtonShown]="forum.HasEditAccess"
                        [isMatRaisedButtonStyle]="true"
                        [isDefaultButton]="false"
                        [isNewMenu]="true"
                        [isAddNewButtonShown]="true"
                        [addNewButtonText]="'common.new_post' | fiAppText"
                        (onEditButtonClick)="editForum()"
                        (onDeleteButtonClick)="deleteForum()"
                        (onAddNewButtonClick)="createNewForumPost()"
                    >
                    </fi-page-header-button-group>
                </div>
            </div>
            <div class="fi-content">
                <fi-forum-view
                    [forum]="forum"
                    [sortList$]="sortList$.asObservable()"
                    (onForumEdit)="editForum()"
                    (onForumDelete)="deleteForum()"
                    (onForumNewPost)="createNewForumPost()"
                >
                </fi-forum-view>
            </div>
        </div>
    `,
    styleUrls: ['../fi-forum-list/fi-forum-list-container.component.scss', './fi-forum-view-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-forum-view-container' },
    standalone: false,
})
export class FiForumViewContainerComponent {
    @Input() forum: IForum;
    @HostBinding('class.mobile-view') get isMobileView(): boolean {
        return this.detectDeviceService.isMobilePhone();
    }

    sortList$: Subject<void> = new Subject<void>();

    constructor(
        private stateService: FiStateService,
        private itemsDeleteHelperService: FiItemsDeleteHelperService,
        private forumService: FiForumSharedService,
        private detectDeviceService: DetectDevicesService,
    ) {}

    editForum(): void {
        this.stateService.go(FiStateNames.Forum.Edit, { id: this.forum.Id });
    }

    deleteForum(): void {
        this.itemsDeleteHelperService.forumDeleteConfirm([this.forum]).then(() =>
            this.forumService.deleteForums([this.forum.Id]).then(() => {
                this.itemsDeleteHelperService.showDeletedObjectSimpleSnackBar(
                    ObjectTypes.Forum,
                    [this.forum.Id],
                    this.forum.Name,
                );
                window.history.back();
            }),
        );
    }

    createNewForumPost(): void {
        if (!this.isMobileView) {
            this.stateService.go(FiStateNames.Forum.Post.Add, { forumId: this.forum.Id });
        } else {
            this.forumService.openForumPostAddScreen(this.forum.Id, () => this.sortList$.next());
        }
    }
}
